module.exports = __webpack_public_path__ + "img/logo.f2a633e2.png";